import { render } from "./preziario.vue?vue&type=template&id=978456bc&ts=true"
import script from "./preziario.vue?vue&type=script&lang=ts"
export * from "./preziario.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__